import { render, staticRenderFns } from "./ScenarioCharactersPanel.vue?vue&type=template&id=1165e16c&scoped=true"
import script from "./ScenarioCharactersPanel.vue?vue&type=script&lang=js"
export * from "./ScenarioCharactersPanel.vue?vue&type=script&lang=js"
import style0 from "./ScenarioCharactersPanel.vue?vue&type=style&index=0&id=1165e16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165e16c",
  null
  
)

export default component.exports